import { ActivatedRouteSnapshot } from '@angular/router';

export function advancedCommerceRunResolvers(from: ActivatedRouteSnapshot, to: ActivatedRouteSnapshot) {
    // resolver on query params change
    return true;
}
